"use client";
import React from "react";
import { motion } from "framer-motion";
const Transition = ({
  children,
  className,
  initial,
  animate,
  transition,
  whileInView,
  viewport,
}) => {
  return (
    <motion.div
      initial={initial}
      animate={animate}
      transition={transition}
      className={className}
      viewport={viewport}
      whileInView={whileInView}
    >
      {children}
    </motion.div>
  );
};

export default Transition;
